import React, { useContext } from 'react';

import { useIsImpersonated, useCurrentUser } from 'Auth';
import AuthContext from 'Auth/AuthContext';
import clsx from 'clsx';

import {
  Avatar,
  IconButton,
  Stack,
  Typography,
  makeStyles,
  CancelPresentationIcon,
} from '@gogame/components';

const useStyles = makeStyles((theme) => {
  return {
    normal: {},
    impersonated: {
      borderRadius: '12px',
      background: theme.palette.secondary.light,
      padding: 'none',
      color: theme.palette.secondary.contrastText,
    },
    avatar: {
      background: theme.palette.action.disabledBackground,
    },
    impersonatedAvatar: {
      background: theme.palette.primary.main,
    },
    text: {
      fontSize: '9px',
    },
    textName: {
      wordBreak: 'break-word',
      fontSize: '10px',
      textDecoration: 'underline dotted',
      lineHeight: '12px',
      marginBottom: theme.spacing(2),
    },
  };
});

export const UserOpener = ({ onClick, className }) => {
  const classes = useStyles();
  const { name, initials } = useCurrentUser();

  const impersonated = useIsImpersonated();

  const { dismissImpersonate } = useContext(AuthContext);

  return (
    <Stack
      alignItems={'center'}
      className={clsx({
        [classes.normal]: !impersonated,
        [classes.impersonated]: impersonated,
      })}
    >
      <IconButton
        tooltip={name}
        tooltipPlacement={'right'}
        onClick={onClick}
        data-cy={'userMenu'}
        className={className}
      >
        <Avatar
          alt={initials}
          className={clsx(classes.avatar, {
            [classes.impersonatedAvatar]: impersonated,
          })}
        >
          <Typography variant={'body2'} color={'text.secondary'}>
            {initials}
          </Typography>
        </Avatar>
      </IconButton>

      {impersonated && (
        <Stack alignItems={'center'}>
          <Typography
            align={'center'}
            className={classes.text}
            color={'inherit'}
          >
            Impersonate
          </Typography>
          <Typography
            gutterBottom={true}
            align={'center'}
            className={classes.textName}
            onClick={onClick}
            color={'inherit'}
          >
            {name}
          </Typography>
          <IconButton
            tooltip={'Dismiss impersonate'}
            tooltipPlacement={'right'}
            onClick={dismissImpersonate}
            icon={<CancelPresentationIcon />}
            color={'inherit'}
            data-cy={'impersonate_dismiss'}
          />
        </Stack>
      )}
    </Stack>
  );
};
